/* eslint-disable camelcase,no-console */

export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		viewInboxPage() {
			amplitude.event( "View Teamless Inbox Page", {} );
		},
    };
};
